export const iconFontAwesomeFoodBeverageBottleDroplet = (
	<i className="fa-solid fa-bottle-droplet"></i>
);
